/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */


import {HttpHeaders} from '@angular/common/http';

/**
 * HTTP headers utilities
 */
export class Headers {

  /**
   * Get a header value, ignoring the case. This is useful since webpack proxy transforms all header keys and makes
   * them lowercase, while in production mode the original case is preserved.
   *
   * See https://github.com/nodejs/node-v0.x-archive/issues/1954
   *
   * @param headers the headers to
   * @param key the header key to get the header value for
   * @returns {string} the value, if header exists, undefined otherwise
   */
  public static get(headers: HttpHeaders, key: string) {
    const lowerCaseKey = headers.keys().find(h => key.toLowerCase() === h.toLowerCase());
    return lowerCaseKey ? headers.get(lowerCaseKey) : undefined;
  }

}
